import React from 'react'

import { Spinner } from '@rewardops/ui/src'

export const Loading = () => <Spinner className="mx-auto mt-4" />
